class WebSocketClient {
	constructor(config) {
		this.url = config.url;
		this.socket = null;
		this.isConnected = false;
		this.reconnectInterval = 5000;
		this.reconnectAttempts = 0;
		this.maxReconnectAttempts = 2;
		this.reconnectTimer = null;
		this.heartbeatInterval = 30000;
		this.heartbeatTimer = null;

		// Обработчики событий
		this.onOpenHandler = null;
		this.onMessageHandler = null;
		this.onErrorHandler = null;
		this.onCloseHandler = null;
		this.onReconnectHandler = null;
	}

	connect() {
		if (this.socket && this.isConnected) {
			console.log('Уже подключено');
			return this;
		}

		if (!this.url) {
			console.log('URL не указан', 'error');
			return this;
		}

		try {
			console.log(`Попытка подключения к ${this.url}`);
			this.socket = new WebSocket(this.url);

			this.socket.onopen = (event) => this.handleOpen(event);
			this.socket.onmessage = (event) => this.handleMessage(event);
			this.socket.onerror = (event) => this.handleError(event);
			this.socket.onclose = (event) => this.handleClose(event);
		} catch (error) {
			console.log(`Ошибка подключения: ${error.message}`, 'error');
			this.scheduleReconnect();
		}

		return this;
	}

	handleOpen(event) {
		console.log('Соединение установлено');
		this.isConnected = true;
		this.reconnectAttempts = 0;

		if (this.onOpenHandler) {
			this.onOpenHandler(event);
		}

		// this.startHeartbeat();
	}

	handleMessage(event) {
		try {
			const data = JSON.parse(event.data);
			console.log('Получено сообщение:', data);

			if (this.onMessageHandler) {
				this.onMessageHandler(data, event);
			}
		} catch (error) {
			console.log('Ошибка парсинга сообщения', 'error');
			if (this.onMessageHandler) {
				this.onMessageHandler(event.data, event);
			}
		}
	}

	handleError(event) {
		console.log('Ошибка WebSocket соединения', 'error');
		console.log(event)

		if (this.onErrorHandler) {
			this.onErrorHandler(event);
		}
	}

	handleClose(event) {
		console.log(`Соединение закрыто. Код: ${event.code}, Причина: ${event.reason}`);
		this.isConnected = false;
		// this.stopHeartbeat();

		if (this.onCloseHandler) {
			this.onCloseHandler(event);
		}

		// Автоматическое переподключение
		if (!event.wasClean && this.reconnectAttempts < this.maxReconnectAttempts) {
			this.scheduleReconnect();
		}
	}

	scheduleReconnect() {
		if (this.reconnectTimer) {
			clearTimeout(this.reconnectTimer);
		}

		this.reconnectAttempts++;
		const delay = this.reconnectInterval * this.reconnectAttempts;

		console.log(`Переподключение через ${delay / 1000} сек. Попытка ${this.reconnectAttempts}/${this.maxReconnectAttempts}`);

		if (this.onReconnectHandler) {
			this.onReconnectHandler(this.reconnectAttempts);
		}

		this.reconnectTimer = setTimeout(() => {
			this.connect();
		}, delay);
	}

	send(command, data = {}) {
		if (!this.isConnected || !this.socket) {
			console.log('Соединение не установлено', 'error');
			return false;
		}

		try {
			const message = JSON.stringify({
				comand: command,
				...data
			});
			console.log(this.socket.readyState)
			this.socket.send(message);
			console.log('Отправлено сообщение:', { command, data });
			return true;
		} catch (error) {
			console.log(`Ошибка отправки: ${error.message}`, 'error');
			return false;
		}
	}

	// startHeartbeat() {
	// 	if (this.heartbeatTimer) {
	// 		clearInterval(this.heartbeatTimer);
	// 	}

	// 	this.heartbeatTimer = setInterval(() => {

	// 		if (this.isConnected) {
	// 			this.send('ping');
	// 		}
	// 	}, this.heartbeatInterval);
	// }

	// stopHeartbeat() {
	// 	if (this.heartbeatTimer) {
	// 		clearInterval(this.heartbeatTimer);
	// 		this.heartbeatTimer = null;
	// 	}
	// }

	disconnect(code = 1000, reason = 'Закрытие по инициативе клиента') {
		this.maxReconnectAttempts = 0; // Отключаем автоматическое переподключение

		if (this.reconnectTimer) {
			clearTimeout(this.reconnectTimer);
		}

		// this.stopHeartbeat();

		if (this.socket) {
			this.socket.close(code, reason);
			this.socket = null;
		}

		this.isConnected = false;
		console.log('Соединение закрыто вручную');
	}

	onOpen(handler) {
		this.onOpenHandler = handler;
		return this;
	}

	onMessage(handler) {
		this.onMessageHandler = handler;
		return this;
	}

	onError(handler) {
		this.onErrorHandler = handler;
		return this;
	}

	onClose(handler) {
		this.onCloseHandler = handler;
		return this;
	}

	onReconnect(handler) {
		this.onReconnectHandler = handler;
		return this;
	}
}

export default WebSocketClient;

